export default "__VITE_ASSET__ea5fc7a0__"